module.exports = __webpack_public_path__ + "887a7c52e054bd389ab37a0619c5b8ec.svg";